import { all, call, delay, fork, put, takeLatest } from "redux-saga/effects";
import * as PointChangeHistory from "../actions/pointChangeHistoryAction"
import { SAGA_DELAY_TIMEOUT } from "../constants/Define";
import * as Types from "../constants/Types";
import * as Func from "../helpers/functions";
import { parseTourListRequestParams } from "../utils/commonUtils";
import * as PointChangeHistoryService from "./../services/pointChangeHistoryService";

function* getListPointChangeHistory() {
  yield takeLatest(
    Types.POINT_CHANGE_HISTORY_GET_LIST_ACTION,
    Func.sagaWrapper(function* (action) {
      const params = parseTourListRequestParams(action.params || {});
      yield delay(SAGA_DELAY_TIMEOUT);
      const result = yield call(PointChangeHistoryService.getListPointChangeHistory, params);
      yield put(PointChangeHistory.setListPointChangeHistory({ ...result, params }));
    }, errorHandlePointChangeHistory(Types.POINT_CHANGE_HISTORY_GET_LIST_FAIL))
  );
}


function errorHandlePointChangeHistory(errorActionType) {
  return Func.sagaErrorHandler(function* (e) {
    yield put({ type: errorActionType });
  }, "pointChangeHistory");
}

export function* pointChangeHistorySaga() {
  yield all([
    //NEW TOUR PROCESSES
    fork(getListPointChangeHistory),
  ]);
}
